export default __webpack_public_path__ + "static/media/epi-worker.51bd9e0f.jpg";